import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { supplierCarService } from '@api/services/services';
import { SupplierCarDto } from '@api/models/suppliers/SupplierCarDto';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

export interface SupplierCarListFilter extends ListFilter {
  supplier?: ReferenceDto;
  type?: string;
  accessAllowed?: boolean;
}

export type SupplierCarListState = ListType<SupplierCarDto, SupplierCarListFilter>;

const initialState: SupplierCarListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'spz',
    sortDesc: false,
  },
};

export const supplierCarListSlice = listSlice({
  name: 'supplierCarList',
  initialState,
});

export const selectSupplierCarList = (state: RootState) => state.supplierCarList;
export const supplierCarListActions = supplierCarListSlice.actions;

export const getSupplierCarList = (supplierId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectSupplierCarList(storeState);

  const handleGetData = (size: number) => {
    return supplierCarService.getAllBySupplier(
      {
        supplierId: supplierId,
        q: data.query.q,
        type: data.query.type,
        accessAllowed: data.query.accessAllowed,
        page: data.query.page,
        size,
        sort: getListSort(data),
      },
      {
        cancelToken: cancelToken,
      }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: supplierCarListActions,
    getData: handleGetData,
  });
};
